import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import AboutV2 from '../src/components/UI/About-v2';

export const serviceLocations: Array<{ imageURL: string; address: string; mapURL: string }> = [
  // { imageURL: '', address: '台北市信義區松仁路100號34樓', mapURL: 'https://goo.gl/maps/W9ef5AGj956vXjwY7' },
  {
    imageURL: '',
    address: '台北市信義區松高路11號25樓（統一國際大樓）',
    mapURL: 'https://maps.app.goo.gl/Yz9aBKDqpqDRUqj3A',
  },
  {
    imageURL: '',
    address: '新竹縣竹北市復興二路281號1樓',
    mapURL: 'https://maps.app.goo.gl/yYcyxuVwU3YSPHpQ6',
  },
  {
    imageURL: '',
    address: '台中市西區館前路57號1樓（全國大飯店）',
    mapURL: 'https://goo.gl/maps/xB97KZTKf3etqjdP8',
  },
];

export default AboutV2;

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
